export default function ModernConstruction() {
  return (
    <section data-testid="construction-section" className="py-10 bg-ecoh-surface">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <h2
              data-testid="construction-headline"
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-[-0.02em] leading-[1.05] text-ecoh-ink"
            >
              Simple to install.
              <br />
              <span>Seamlessly integrated.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-ecoh-muted text-base md:text-lg leading-relaxed font-light">
              Ultra-thin heating film designed for easy integration into new builds,
              renovations, and retrofit projects with minimal system complexity.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
